import styled from 'styled-components';

export const PointExpireLogDetailContainerStyled = styled.div`
  position: relative;
  width: 92vw;
  max-width: 1040px;
  max-height: 88vh;
  overflow: auto;
  padding: 1.5rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 8px;
  font-size: 14px;
  .modal_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    .modal_title {
      font-size: 18px;
    }
    .close_btn {
      cursor: pointer;
      font-size: 18px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      padding: 0 4px;
    }
  }
  .empty {
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .two_col {
    display: flex;
    gap: 24px;
    .section {
      flex: 1;
      min-width: 0;
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
    .two_col {
      flex-direction: column;
      gap: 0;
    }
  }
  .section {
    margin-bottom: 16px;
    .section_title {
      margin-bottom: 8px;
      color: #2b4a70;
    }
  }
  .info_row {
    display: flex;
    gap: 12px;
    padding: 6px 0;
    border-bottom: 1px solid #f0f2f5;
    .info_label {
      width: 150px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .info_value {
      flex: 1;
      word-break: break-word;
    }
  }
  .run_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
    .run_grid {
      grid-template-columns: 1fr;
    }
  }
  .danger_text {
    color: #c62828;
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_processing,
  .status_running,
  .status_partial {
    background: #fff3dc;
    color: #b26a00;
  }
  .error_box {
    margin-bottom: 16px;
    padding: 12px 14px;
    border: 1px solid #f5c2c2;
    border-radius: 6px;
    background: #fff5f5;
    .error_title {
      color: #c62828;
      margin-bottom: 4px;
    }
    .error_message {
      white-space: pre-wrap;
      word-break: break-word;
      font-size: 13px;
    }
  }
  .note_box {
    margin-bottom: 16px;
    padding: 10px 14px;
    border: 1px solid #dbe4f0;
    border-radius: 6px;
    background: #f7f9fc;
    color: #435466;
    font-size: 13px;
    line-height: 1.6;
  }
  .table_wrap {
    overflow-x: auto;
  }
  .item_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    th,
    td {
      padding: 6px 8px;
      border: 1px solid #e4e8ee;
      text-align: left;
    }
    th {
      background: #f2f6fc;
      white-space: nowrap;
    }
    .right {
      text-align: right;
    }
    .bold {
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
  }
  .repair_box {
    margin-bottom: 16px;
    padding: 14px;
    border: 1px solid #ffd9a8;
    border-radius: 8px;
    background: #fff8ec;
    .repair_title {
      color: #8a4b00;
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      margin-bottom: 6px;
    }
    .repair_desc {
      margin-bottom: 10px;
      color: #435466;
      font-size: 13px;
      line-height: 1.7;
    }
    textarea {
      height: 80px;
    }
    .repair_action {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .btn_box {
        width: 240px;
      }
    }
  }
  .action_zone {
    display: flex;
    justify-content: flex-end;
    .btn_box {
      width: 140px;
    }
  }
`;
